import { combineReducers, createStore, applyMiddleware } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension';
import thunk from 'redux-thunk';
import authReducer from './auth/reducer';
import customersReducer from './customers/reducer';
import hubOwnerReducer from './hubOwner/reducer';
import dashboardUserReducer from './dashboardUser/reducer';
import devicesReducer from './devices/reducer';
import facilityReducer from './facility/reducer';
import myAccountReducer from './myAccount/reducer';
import pharmacyReducer from './pharmacy/reducer';
import reportingReducer from './reporting/reducer';
import softwareReducer from './software/reducer';
import mqttReducer from './mqtt/reducer';
import medicationsReducer from './medications/reducer';
import MQTTMiddleware from '../middleware/mqtt';
import { AuthStore } from './auth/authTypes';
import { CustomerStore } from './customers/customerTypes';
import { DashboardUserStore } from './dashboardUser/dashboardUserTypes';
import { DevicesStore } from './devices/deviceTypes';
import { FacilityStore } from './facility/facilityTypes';
import { MyAccountStore } from './myAccount/myAccountTypes';
import { ReportingStore } from './reporting/reportingTypes';
import { MQTTConnectionStore } from './mqtt/mqttTypes';
import { PharmacyStore } from './pharmacy/pharmacyTypes';
import { SoftwareStore } from './software/softwareTypes';
import { HubOwnerStore } from './hubOwner/types';
import { MedicationStore } from './medications/types';
import { UIToggleStore } from './uiToggle/uiToggleTypes';
import uiToggleReducer from './uiToggle/reducer';
import overviewStatsReducer from './overviewStats/reducer';
import { OverviewStatsStore } from './overviewStats/overviewStatsTypes';
import pharmacyPatientsReducer from './pharmacyPatients/reducer';
import { PharmacyPatientsStore } from './pharmacyPatients/pharmacyPatientsTypes';
import documentsReducer from './documents/reducer';
import { DocumentsStore } from './documents/documentsTypes';
import callStatsReducer from './callStats/reducer';
import { CallStatsStore } from './callStats/callStatsTypes';
import callsReducer from './calls/reducer';
import { CallsStore } from './calls/callsTypes';

export interface AppState {
  auth: AuthStore;
  customers: CustomerStore;
  dashboardUser: DashboardUserStore;
  devices: DevicesStore;
  facility: FacilityStore;
  myAccount: MyAccountStore;
  pharmacy: PharmacyStore;
  reporting: ReportingStore;
  software: SoftwareStore;
  mqtt: MQTTConnectionStore;
  hubOwner: HubOwnerStore;
  medications: MedicationStore;
  uiToggle: UIToggleStore;
  overviewStats: OverviewStatsStore;
  pharmacyPatients: PharmacyPatientsStore;
  documents: DocumentsStore;
  callStats: CallStatsStore;
  calls: CallsStore;
}

let rootReducer = combineReducers({
  auth: authReducer,
  customers: customersReducer,
  dashboardUser: dashboardUserReducer,
  devices: devicesReducer,
  facility: facilityReducer,
  myAccount: myAccountReducer,
  pharmacy: pharmacyReducer,
  reporting: reportingReducer,
  software: softwareReducer,
  mqtt: mqttReducer,
  hubOwner: hubOwnerReducer,
  medications: medicationsReducer,
  uiToggle: uiToggleReducer,
  overviewStats: overviewStatsReducer,
  pharmacyPatients: pharmacyPatientsReducer,
  documents: documentsReducer,
  callStats: callStatsReducer,
  calls: callsReducer,
});

const redux_middleware = [MQTTMiddleware, thunk];

export const RootStore = createStore<AppState, any, any, any>(
  rootReducer,
  composeWithDevTools(applyMiddleware(...redux_middleware)),
);

export type RootState = ReturnType<typeof rootReducer>;

export type AppDispatch = typeof RootStore.dispatch;
